module.exports = __webpack_public_path__ + "static/media/blog03.404d1a40.png";